import { type SelectOption } from '../../../../../components';

export enum ProofDocumentType {
  PUBLIC = 'PUBLIC',
  INTERNAL = 'INTERNAL',
  RESTRICTED = 'RESTRICTED',
}

export const proofDocumentTypeOptions: SelectOption[] = [
  {
    value: ProofDocumentType.PUBLIC,
    label: 'Public',
  },
  {
    value: ProofDocumentType.INTERNAL,
    label: 'Internal',
  },
  {
    value: ProofDocumentType.RESTRICTED,
    label: 'Restricted',
  },
];
